// src/main.js
import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from 'axios'
import { library } from '@fortawesome/fontawesome-svg-core'
import {
    faBook, faBookOpen, faUserClock, faHistory,
    faPlus, faSearch, faTimes, faCog, faChair,
    faBell, faChartLine, faUserCircle, faSignOutAlt,
    faCalendarAlt, faCheckCircle, faClock,
    faNetworkWired, faUser, faServer, faDatabase
} from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

// 添加图标
library.add(
    faBook, faBookOpen, faUserClock, faHistory,
    faPlus, faSearch, faTimes, faCog, faChair,
    faBell, faChartLine, faUserCircle, faSignOutAlt,
    faCalendarAlt, faCheckCircle, faClock, faNetworkWired, faUser, faServer, faDatabase
)

// 设置全局样式
import './assets/global.css'

// 设置axios默认配置
axios.defaults.baseURL = 'http://localhost:5678'
axios.defaults.headers.post['Content-Type'] = 'application/json'

const app = createApp(App)

app.use(store)
app.use(router)
app.component('font-awesome-icon', FontAwesomeIcon)

// 添加全局错误处理方法
app.config.globalProperties.$showNotification = function (message) {
    this.$refs.notificationManager?.addMessage(message);
};

app.mount('#app')
window.app = app

// 全局错误处理
window.addEventListener('error', (event) => {
    app.config.globalProperties.$showNotification(`全局错误: ${event.message}`);
});